import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
var rules = [
// Customer
{
  from: '^ovatu://customer/([0-9]+)/view',
  to: '/customer/$1'
},
// Customer form
// { from: '^ovatu://customer/([0-9]+)/forms', to: '/customer/$1?tab=forms' },

// Customer form
{
  from: '^ovatu://customer/([0-9]+)/forms\\?idCustomerForm=([0-9]+)',
  to: '/customer/form/view?id=$2',
  component: 'o-panel-link'
},
// Customer message
{
  from: '^ovatu://customer/([0-9]+)/message\\?idCustomerMessage=([0-9]+)',
  to: '/message/chat/$1',
  component: 'o-panel-link'
},
// Reservation
{
  from: '^ovatu://reservation/([0-9]+)/view\\?date=([0-9]{6})',
  to: '/appointment/$1?date=$2',
  component: 'o-panel-link'
},
// Order
{
  from: '^ovatu://order/([0-9]+)/view',
  to: '/order/$1',
  component: 'o-panel-link'
},
// Waitlist
{
  from: '^ovatu://waitlist/([0-9]+)/view',
  to: '/waitlist/$1',
  component: 'o-panel-link'
},
// Reviews
{
  from: '^ovatu://review/list',
  to: '/review'
},
// Review
{
  from: '^ovatu://review/([0-9]+)/view',
  to: '/marketing/reviews/review?id=$1',
  component: 'o-panel-link'
},
// Messages
{
  from: '^ovatu://messages/list',
  to: '/message'
},
// SMS settings
{
  from: '^ovatu://settings/sms',
  to: '/manage/sms'
},
// Plan settings
{
  from: '^ovatu://settings/plan',
  to: '/account/billing'
},
// Integration authentication
{
  from: '^ovatu://integration/(\\w+)/authenticate',
  to: '/integration/$1',
  component: 'o-panel-link'
},
// Resend email verification
{
  from: '^ovatu://settings/verify',
  to: '/account/verify'
},
// Password
{
  from: '^ovatu://settings/password',
  to: '/account/users/users'
},
// Minisite settings
{
  from: '^ovatu://settings/minisite',
  to: '/minisite'
},
// Policy settings
{
  from: '^ovatu://settings/policy\\?policy=(\\w+)',
  to: '/account/policy?policy=$1'
},
// Reservation list
{
  from: '^ovatu://reservation/list\\?ids=([&\\w]+)',
  to: '/appointment/list?ids=$1',
  component: 'o-panel-link'
},
// Order list
{
  from: '^ovatu://order/list\\?ids=([&\\w]+)',
  to: '/order/list?ids=$1',
  component: 'o-panel-link'
},
// Cutomer list
{
  from: '^ovatu://customer/list\\?ids=([&\\w]+)',
  to: '/customer/list?ids=$1',
  component: 'o-panel-link'
},
// Minisite home
{
  from: '^ovatu://minisite/home',
  to: function to(url, context) {
    var domain = context.$config.bookappDomain;
    var slug = context.$auth.info.location.slug;
    return 'https://' + slug + '.' + domain;
  },
  component: 'a'
}];
export default (function (context, inject) {
  var plugin = {
    match: function match(url) {
      var found = this.rules.find(function (rule) {
        return rule.from.test(url);
      });
      var path = '/';
      if (found) {
        if (found.to instanceof Function) {
          path = found.to(url, context);
        } else {
          path = url.replace(found.from, found.to);
        }
      }
      var component = (found === null || found === void 0 ? void 0 : found.component) || 'nuxt-link';
      return {
        path: path,
        component: component
      };
    },
    route: function route(url) {
      var path = this.convert(url);
      context.router.go(path);
    },
    get rules() {
      return rules.map(function (rule) {
        return _objectSpread(_objectSpread({}, rule), {}, {
          from: new RegExp(rule.from)
        });
      });
    }
  };
  inject('redirect', plugin);
});